import React, { FC } from 'react';

import { IGood } from 'entities/products';

import { AssemblySvg } from 'assets/svg/USPsvg/AssemblySvg';
import { AssemblyProfSvg } from 'assets/svg/USPsvg/AssemblyProfSvg';
import { LiftSvg } from 'assets/svg/USPsvg/LiftSvg';

import styles from './styles.module.scss';

type Props = {
  initialProduct: IGood;
};

const getProductUspSVG = (initialProduct) => {
  switch (initialProduct.assembly) {
    case 'SIMPLY':
      return <AssemblySvg />;
    case 'PROFESSIONAL':
      return <AssemblyProfSvg />;
    default:
      break;
  }
};

const getProductUspText = (initialProduct) => {
  switch (initialProduct.assembly) {
    case 'SIMPLY':
      return (
        <>
          Бесплатно <span>соберет экипаж</span>
        </>
      );
    case 'PROFESSIONAL':
      return (
        <>
          <span>Организуем сборку</span>
        </>
      );
    default:
      break;
  }
};

const ProductUSP: FC<Props> = ({ initialProduct }) => {
  return (
    <div className={styles.uspContainer}>
      <div className={styles.cardUSPContainer}>
        <div className={styles.cardUSPContent}>
          <LiftSvg />
          <h4 className={`${styles.coloredLabel} ${styles.coloredLabel}`}>
            Бесплатно <span>поднимем на лифте</span>
          </h4>
        </div>
      </div>
      {initialProduct.assembly !== 'NONE' && (
        <div className={styles.cardUSPContainer}>
          <div className={styles.cardUSPContent}>
            {getProductUspSVG(initialProduct)}
            <h4 className={`${styles.coloredLabel} ${styles.coloredLabel}`}>{getProductUspText(initialProduct)}</h4>
          </div>
        </div>
      )}
    </div>
  );
};

export { ProductUSP };
